import { Observable } from './zenObservable';
export * from './zenObservable';
export default Observable;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/apollo-boost/~/zen-observable-ts/lib/index.js
// module id = 206
// module chunks = 0